import { createContext, useContext } from 'react'

export const ClientAccountsTableContext = createContext({})

export const useClientAccountsActions = () => {
  return useContext(ClientAccountsTableContext)
}
